import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import { isUserProfileActionAddNew } from '../../User'

import {
  USER_PROFILE_PAGE_HEADER_FOOTER_ACTION,
  USER_PROFILE_PAGE_HEADER_FOOTER_ACTION_PERMISSION,
  USER_PROFILE_PAGE_HEADER_FOOTER_ACTION_TEXT_KEY,
  USER_PROFILE_PAGE_HEADER_FOOTER_ADD_NEW_ACTIONS,
  USER_PROFILE_PAGE_HEADER_FOOTER_PRIMARY_ACTION_BY_STATUS,
} from './UserProfilePageHeaderFooter.constants'

function getActionPermission({ action, permissions = EMPTY_OBJECT }) {
  return permissions[USER_PROFILE_PAGE_HEADER_FOOTER_ACTION_PERMISSION[action]]
}

function getAddNewActionExtraPermission({
  action,
  canCreateEmails,
  canViewChats,
  userData,
}) {
  switch (action) {
    case USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.email:
      return Boolean(canCreateEmails)
    case USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.folder:
    case USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.upload:
      return Boolean(userData.directory_id)
    case USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.sendMessage:
      return Boolean(canViewChats)
    default:
      return true
  }
}

function getPrimaryAction({ addNewOptions, userData }) {
  const action = userData.isArchived
    ? USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.restore
    : USER_PROFILE_PAGE_HEADER_FOOTER_PRIMARY_ACTION_BY_STATUS[userData.status]

  if (isUserProfileActionAddNew(action)) {
    return addNewOptions.length > 0 ? action : null
  }

  return getActionPermission({
    action,
    permissions: userData.permissions,
  })
    ? action
    : null
}

export function isUserProfilePageAddNewActionPermitted({
  action,
  canCreateEmails,
  canViewChats,
  permissionOverrideByAction = EMPTY_OBJECT,
  userData,
}) {
  return Boolean(
    (permissionOverrideByAction[action] ??
      getActionPermission({ action, permissions: userData.permissions })) &&
    getAddNewActionExtraPermission({
      action,
      canCreateEmails,
      canViewChats,
      userData,
    })
  )
}

export function getUserProfilePageHeaderFooterAddNewOptions({
  canCreateEmails,
  canViewChats,
  permissionOverrideByAction,
  t,
  userData,
}) {
  return USER_PROFILE_PAGE_HEADER_FOOTER_ADD_NEW_ACTIONS.map(action => ({
    label: t(USER_PROFILE_PAGE_HEADER_FOOTER_ACTION_TEXT_KEY[action]),
    permission: isUserProfilePageAddNewActionPermitted({
      action,
      canCreateEmails,
      canViewChats,
      permissionOverrideByAction,
      userData,
    }),
    value: action,
  })).filter(item => item.permission)
}

export function getUserProfilePageHeaderFooterActionsConfig({
  canCreateEmails,
  canViewChats,
  t,
  userData,
}) {
  if (!userData) {
    return {
      addNewOptions: EMPTY_LIST,
      primaryAction: null,
    }
  }

  const addNewOptions = getUserProfilePageHeaderFooterAddNewOptions({
    canCreateEmails,
    canViewChats,
    t,
    userData,
  })

  const primaryAction = getPrimaryAction({ addNewOptions, userData })

  return { addNewOptions, primaryAction }
}
